import { ValidateJSModel } from 'forms/shared/types';
import { convertDateRangesToMarkdown, findTimelineGaps } from 'helpers/date';
import { getDuplicatePeople } from 'helpers/people';
import { isPVQForm } from 'helpers/form';
import { RelationshipsPeopleModel } from './types';
import relationshipsPeopleItemValidator from './validators/item';

const relationshipsPeopleValidator: ValidateJSModel<RelationshipsPeopleModel> = {
  List: (value, attributes, attributeName, options) => {
    let additionalValidation = {};
    const { errors = [] } = getDuplicatePeople(value?.items);

    if (errors && errors?.length > 0) {
      additionalValidation = {
        requireTrue: { // force error message; value will never be true
          message: 'relationships.people.error.duplicateListItems',
        }
      };
    }

    return {
      ...additionalValidation,
      presence: true,
      accordion: {
        validator: relationshipsPeopleItemValidator,
        length: { minimum: 3, tooShort: 'error.list.length.relationshipsPeople' },
      },
      durationCoverage: (value, attributes, attributeName, options) => {
        const { requireYears } = options;
        const presentChecked = value?.items?.some((element) => element?.Item?.Dates?.present === true);
        if (isPVQForm(options?.formType)) {
          return {
            requirePresent: false,
            requiredDuration: { years: 5 },
            incompleteDuration: {
              code: 'error.gap.relationshipsPeople',
              localeOptions: {
                messageParameters: {
                  years: requireYears,
                  gaps: convertDateRangesToMarkdown(
                    findTimelineGaps(
                      { year: requireYears },
                      value?.items?.map((e) => e?.Item?.Dates)
                    )
                  ),
                },
              },
            },
          };
        }
        return {
          requirePresent: !presentChecked,
          requirePresentMessage: 'error.presentUnchecked.relationshipsPeople',
          requiredDuration: { years: requireYears },
          incompleteDuration: {
            code: 'error.gap.relationshipsPeople',
            localeOptions: {
              messageParameters: {
                years: requireYears,
                gaps: convertDateRangesToMarkdown(
                  findTimelineGaps(
                    { year: requireYears },
                    value?.items?.map((e) => e?.Item?.Dates)
                  )
                ),
              },
            },
          },
        };
      },
    };
  },
  Comments: {},
};

export default relationshipsPeopleValidator;
